import { removeArrayElement } from "../../../utils/general";
import { ADD_PAYMENT, DELETE_PAYMENTS, FETCH_PAYMENTS, LOG_OUT_USER } from "../../actions/actionTypes";

const fetchPaymentsReducer = (payments, payload) => {

    let newPayments = payload.appendData || payload.offset == ""? [ ...payments ] : []
    for(let payment of payload.payments){
        newPayments.push(payment.paymentId);
    }
    let uniqueIds = [...new Set(newPayments)];
    return uniqueIds;
}

const addPaymentReducer = (payments, payload) => {
    let newPayments = [ ...payments ];
    newPayments.unshift(payload.payment.paymentId)

    return newPayments;
}

const deletePaymentsReducer = (payments, payload) => {
    let remainingPayments = [ ...payments ];
    for (const paymentId of payload.paymentIds) {
      remainingPayments = removeArrayElement(remainingPayments, paymentId);
    }
    return remainingPayments;
  }  

const paymentsOrderReducer = (state=[], action) => {
    let payments = state;
    if (action && action.payload && !action.errors && !action.payload.errors){
        switch(action.type){
            case FETCH_PAYMENTS:
                return fetchPaymentsReducer(payments, action.payload);
            case ADD_PAYMENT:
                return addPaymentReducer(payments, action.payload);
            case DELETE_PAYMENTS:
                return deletePaymentsReducer(payments, action.payload);
            case LOG_OUT_USER:
                return [];
            default:
                return payments;
        }
    }
    return payments;
}

export default paymentsOrderReducer;